var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_vm.featureEnabled ? _c('div', {
    staticClass: "rounded_corner"
  }, [_c('div', {
    staticClass: "panel-pane"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        New - SciShield brings access to Health and Safety SOPs through\n        eLabNext\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content-top"
    }
  }, [_c('div', {
    staticClass: "clear-block block block-scisure_integration",
    attrs: {
      "id": "block-scisure_integration-0"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "elabnext-blocks"
    }
  }, [_c('VActionButton', {
    attrs: {
      "show-badge": false,
      "show-icon": false,
      "label": "Go to eLabNext"
    },
    on: {
      "click": _vm.goToELabNext
    }
  })], 1)])])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', [_c('li', [_vm._v("\n                Centralized access to all organization's SOPs for Researchers.\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                Create research protocols and share them with the members in\n                your lab.\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                Further extend the use of research protocols and SOPs with the\n                integrated Electronic Lab Notebook and Sample Management\n                Capabilities of eLabNext.\n              ")])]);

}]

export { render, staticRenderFns }